module.exports = __webpack_public_path__ + "img/promotion_12_01.jpg";